import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeComponent } from './landings/home/home.component';
import { PagesRoutingModule } from './pages.routing';
import { PurchaseModule } from './purchase/purchase.module';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../common/pipes/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { ComponentsModule } from '../shared/components/components.module';
import { NgxMaskPipe } from 'ngx-mask';
import { DirectivesModule } from '@/common/directives/directives.module';

@NgModule({
    declarations: [HomeComponent],
    exports: [HomeComponent],
    imports: [
        CommonModule,
        NgbModule,
        PagesRoutingModule,
        PurchaseModule,
        TranslateModule.forChild({
            extend: true,
        }),
        SharedModule,
        ComponentsModule,
        PipesModule,
        NgxMaskPipe,
        DirectivesModule,
    ],
    providers: [],
    bootstrap: [],
})
export class PagesModule {}
